import { Table } from "containers/Table";
import {
  Button,
  Container,
  ContainerInputPesquisa,
  DivAcoes,
  Header,
  Icon,
  InputPesquisa,
  InputWrapper,
  TextoHeader,
} from "./style";
import { IColum } from "containers/Table/interfaces";
import { useEffect, useState } from "react";
import { IProcessoVincularLoteLicenciamentos } from "../../Interfaces/IProcessoVincularLoteLicenciamentos";

interface IProps {
  clearRows: boolean;
  setRowsSelected: (ids: number[]) => void;
  dados: IProcessoVincularLoteLicenciamentos[];
  selectedRows: number[];
  onClickAddProcesso: () => void;
  tela: string;
}
export function ListaProcessosVincularLoteLicenciamentos({
  clearRows,
  setRowsSelected,
  dados,
  selectedRows,
  onClickAddProcesso,
  tela,
}: IProps) {
  const [dadosTabela, setDadosTabela] = useState<
    IProcessoVincularLoteLicenciamentos[]
  >([...dados]);
  const [textoBusca, setTextoBusca] = useState<string>("");
  const onChangePesquisa = (buscar: string) => {
    if (!buscar) {
      setDadosTabela([...dados]);
      return;
    }

    setDadosTabela(
      [...dados].filter((item) => {
        if (
          `${item.idProcesso}`.includes(buscar) ||
          (item.placa &&
            item.placa.replace("-", "").includes(buscar.replace("-", "")))
        ) {
          return true;
        }
        return false;
      }),
    );
  };

  useEffect(() => {
    setTextoBusca("");
    setDadosTabela(dados);
  }, [dados]);

  const columns: IColum<IProcessoVincularLoteLicenciamentos>[] = [
    {
      name: "Processo",
      selector: ({ idProcesso }: IProcessoVincularLoteLicenciamentos) =>
        idProcesso,
    },
    {
      name: "Placa",
      selector: ({ placa }: IProcessoVincularLoteLicenciamentos) =>
        placa ?? "--",
    },
    {
      name: "Renavam",
      selector: ({ renavam }: IProcessoVincularLoteLicenciamentos) =>
        renavam ?? "--",
    },
    {
      name: "Chassi",
      selector: ({ chassi }: IProcessoVincularLoteLicenciamentos) =>
        chassi ?? "--",
      width: "200px",
    },
    {
      name: "UF",
      selector: ({ uf }: IProcessoVincularLoteLicenciamentos) => uf ?? "--",
      width: "200px",
    },
    {
      name: "Serviço",
      selector: ({ servicoProcesso }: IProcessoVincularLoteLicenciamentos) =>
        servicoProcesso ?? "--",
      width: "250px",
    },
  ];

  return (
    <Container>
      <Header>
        <TextoHeader>
          Selecione o(s) processos(s) que deseja adicionar ao lote
        </TextoHeader>
        <DivAcoes>
          <Button
            variante="primary"
            onClick={onClickAddProcesso}
            disabled={!selectedRows.length}
          >
            Adicionar processos
          </Button>
        </DivAcoes>
      </Header>
      <hr />
      <ContainerInputPesquisa>
        <InputWrapper>
          <Icon />
          <InputPesquisa
            value={textoBusca}
            onChange={(e) => {
              setTextoBusca(e.target.value);
              onChangePesquisa(e.target.value);
            }}
            placeholder="ID Processo ou placa"
          />
        </InputWrapper>
      </ContainerInputPesquisa>
      <Table
        key={tela}
        keyField="idProcesso"
        columns={columns}
        data={dadosTabela}
        loading={false}
        noSubHeader
        possuiTooltip={false}
        selectableRows
        setRowsSelected={setRowsSelected}
        headerFixo
        clearSelectedRows={clearRows}
      />
    </Container>
  );
}
